import { render, staticRenderFns } from "./redPoolAccountName.vue?vue&type=template&id=1b22eab6&scoped=true"
import script from "./redPoolAccountName.vue?vue&type=script&lang=js"
export * from "./redPoolAccountName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22eab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b22eab6')) {
      api.createRecord('1b22eab6', component.options)
    } else {
      api.reload('1b22eab6', component.options)
    }
    module.hot.accept("./redPoolAccountName.vue?vue&type=template&id=1b22eab6&scoped=true", function () {
      api.rerender('1b22eab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-k/components/redPoolAccountName.vue"
export default component.exports